<div id="wrapper">
    <app-loading-screen [status]=true></app-loading-screen>
    <div class="allcont">
      <app-menu [tabActive]="this.tabActive"></app-menu>
  
      <div class="basicrow mbott">
        <div class="container">
          <div class="fulltitle m-top-i f-btitle">
            <i class="fa fa-briefcase" aria-hidden="true"></i> {{this.companyName}}
          </div>
  
          <div class="basicrow m-top">
            <div class="autowcont m-bott">
              <div class="basicrow msidespad border-bottom">
                <div class="b-title noline">
                  <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                    <div class="tabcell">
                      Historial de Pagos
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="basicrow">
                <div class="basicrow allpads">
                  <div class="basicrow">
                      <div class="autorow subsc pull-left mob-wid">
                        <label class="label-r">Filtro de Búsqueda:</label>
                
                        <div class="basicrow">
                          <select (change)="updateBillsPaymentChange()" [(ngModel)]="selectBan" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                            <option disabled value="">N&uacute;mero de Cuenta</option>
                            <option *ngFor="let account of this.banlist" [ngValue]="account.account">{{account.account}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="autorow subsc pull-left mleft-select " [hidden]="false">
                        <label class="label-r">Año</label>
                        <div class="basicrow">
                            <select (change)="updateBillsPaymentChange()" [(ngModel)]="selectYear" class="sel-f yearSelect" style="background-image:url(/assets/images/selectabarrw.png)">
                              <option  disabled value="">Año</option>
                              <option *ngFor="let year of this.yearList" [ngValue]="year">{{year}}</option>
                            </select>
                        </div>
                      </div>
                  </div>
  
                  <div class="basicrow m-top-i text-justify">
                    Si su pago aparece en estado de <span class="roboto-b">iniciado</span> o <span class="roboto-b">procesado</span>, su pago est&aacute; siendo procesado por nuestro sistema e instituci&oacute;n bancaria. De su pago no ser procesado exitosamente por el banco o nuestro sistema, el mismo ser&aacute; eliminado de nuestro sistema autom&aacute;ticamente. Esta lista s&oacute;lo contiene pagos efectuados los &uacute;ltimos 13 meses.
                  </div>
                </div>
  
                <div class="basicrow msidespad roboto-b f-black f-reg m-bott">
                  <div class="basicrow topbord">
                    Factura Actual
                  </div>
                </div>
  
                <div class="basicrow visible-web">
                  <div class="tab-tbar">
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        Fecha de Facturaci&oacute;n
                      </div>
                    </div>
  
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        M&eacute;todo
                      </div>
                    </div>
  
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        Status
                      </div>
                    </div>
  
                    <div class="frwds vcenter">
                      <div class="tabcell">
                        Cantidad
                      </div>
                    </div>
                  </div>
                  <div class="notData" *ngIf="this.invoicesHistory.length==0">No hay datos disponibles.</div>
                  <div class="basicrow" *ngFor="let invoiceHistory of this.invoicesHistory; let i = index">
                    <div class="tab-cbar">
                      <div class="frwds rline vcenter">
                        <div class="tabcell">
                          {{invoiceHistory.Fecha}}
                        </div>
                      </div>
  
                      <div class="frwds rline vcenter">
                        <div class="tabcell">
                          {{invoiceHistory.Metodo}}
                        </div>
                      </div>
  
                      <div class="frwds rline vcenter">
                        <div class="tabcell">
                          {{invoiceHistory.Status}}
                        </div>
                      </div>
  
                      <div class="frwds vcenter">
                        <div class="tabcell">
                          {{invoiceHistory.Cantidad}}
                        </div>
                      </div>
                    </div>
  
                  </div>
                </div>

                <!-- [INIT TABLA MOVIL] -->
                <div class="basicrow m-top visible-movil">
                    <div class="basicrow mbott-i" id="last-div">
                      <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
                        <!-- Indicators -->
                        <ol class="carousel-indicators bot-select">
                          <li data-target="#myCarousel5" data-slide-to="0" class="active"></li>
                          <li data-target="#myCarousel5" data-slide-to="1"></li>
                        </ol>
                        
                        <!-- Wrapper for slides -->
                        <div class="carousel-inner">
                            <carousel  [interval]="false">
                          <slide>
                          <div class="item active">
                            <div class="boxtbl">
                            <div class="tab-tbar" >
                              <div class="frwds rline vcenter">
                                <div class="tabcell">
                                  Fecha de Facturaci&oacute;n
                                </div>
                              </div>
        
                              <div class="frwds vcenter">
                                <div class="tabcell">
                                  M&eacute;todo
                                </div>
                              </div>
                            </div>
                            <div class="basicrow">
                              <div class="notData" *ngIf="this.invoicesHistory.length==0">No hay datos disponibles.</div>
                              <div class="tab-cbar" *ngFor="let invoiceHistory of this.invoicesHistory; let i = index">
                                <div class="frwds rline vcenter">
                                  <div class="tabcell">
                                    {{invoiceHistory.Fecha}} 
                                  </div>
                                </div>
        
                                <div class="frwds vcenter">
                                  <div class="tabcell">
                                    {{invoiceHistory.Metodo}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        </slide>
                          <slide>
                          <div class="item">
                            <div class="boxtbl">
                            <div class="tab-tbar">
                              <div class="frwds rline vcenter">
                                <div class="tabcell">
                                  Status
                                </div>
                              </div>
        
                              <div class="frwds vcenter">
                                <div class="tabcell">
                                  Cantidad
                                </div>
                              </div>
                            </div>
                            <div class="basicrow">
                               <div class="notData" *ngIf="this.invoicesHistory.length==0">No hay datos disponibles.</div>
                              <div class="tab-cbar" *ngFor="let invoiceHistory of this.invoicesHistory; let i = index">
                                <div class="frwds rline vcenter">
                                  <div class="tabcell">
                                    {{invoiceHistory.Status}}
                                  </div>
                                </div>
        
                                <div class="frwds vcenter">
                                  <div class="tabcell">
                                    <span class="roboto-b">
                                      {{invoiceHistory.Cantidad}}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        </slide>
                      </carousel> 
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- [END TABLA MOVIL] -->
  
               
            <div class="basicrow m-top m-bott text-center" style="display: none;">
                <div class="autorow cntrpager">
                  <a class="tablepages off vcenter">
                                                <span class="tabcell">
                                                    &lt;&lt;
                                                </span>
                  </a>

                  <a class="tablepages off vcenter">
                                                <span class="tabcell">
                                                    &lt;
                                                </span>
                  </a>

                  <a class="tablepages on vcenter">
                                                <span class="tabcell">
                                                    1
                                                </span>
                  </a>

                  <a class="tablepages vcenter">
                                                <span class="tabcell">
                                                    2
                                                </span>
                  </a>

                  <a class="tablepages vcenter">
                                                <span class="tabcell">
                                                    3
                                                </span>
                  </a>

                  <a class="tablepages vcenter">
                                                <span class="tabcell">
                                                    &gt;
                                                </span>
                  </a>

                  <a class="tablepages vcenter">
                                                <span class="tabcell">
                                                    &gt;&gt;
                                                </span>
                  </a>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  
    <app-footer></app-footer>
  </div>
  